import { useCallback } from "react";

import { useAppSelector } from "../app/store/hooks";
import { logEvents } from "../utils/logging";

const useLogRecipeEdit = () => {
    const user = useAppSelector((state) => state.main.user);
    const device = useAppSelector((state) => state.main.device);
    const { displayName: deviceName, _id: deviceId } = device ?? {};

    const logRecipeEdit = useCallback((EVENT_NAME: string, payload?: any) => {
        const eventData = {
            userId: user?.id,
            deviceId: deviceName ?? deviceId,
            ...payload
        }
        logEvents("null", EVENT_NAME, eventData);
    }, [user, device])

    return { logRecipeEdit }
}

export default useLogRecipeEdit;
